import { useRequiredContext } from "@redotech/react-util/context";
import { useAskRedoSlidePanel } from "@redotech/redo-merchant-app-common/ask-redo/ask-redo-slide-panel-context";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import {
  globalSearchCategory,
  GlobalSearchCategory,
} from "@redotech/redo-model/global-search/global-search-category";
import {
  CommandPaletteFilter,
  CommandPaletteProvider,
} from "@redotech/redo-web/command-palette/contexts/command-palette-context";
import { memo, useCallback } from "react";
import { useSearchHistory } from "../side-navigation/use-search-history";
import { useSearchItems } from "../side-navigation/use-search-items";

interface GlobalSearchProps {
  children: React.ReactNode;
}

export const GlobalSearch = memo(function GlobalSearch({
  children,
}: GlobalSearchProps) {
  const { searchHistory, saveToSearchHistory } = useSearchHistory();
  const merchantRpcClient = useRequiredContext(RedoMerchantRpcClientContext);
  const askRedoPanel = useAskRedoSlidePanel();
  const onSearch = useSearchItems(merchantRpcClient);

  const onAskAI = useCallback(
    (searchValue: string) => {
      askRedoPanel.open({
        kind: "prefill",
        input: searchValue,
        autoSubmit: true,
      });
    },
    [askRedoPanel],
  );

  const onAction = useCallback(
    (search: string) => {
      saveToSearchHistory(search);
    },
    [saveToSearchHistory],
  );

  return (
    <CommandPaletteProvider
      filters={filters}
      initialResults={searchHistory}
      onAction={onAction}
      onAskAI={onAskAI}
      onSearch={onSearch}
    >
      {children}
    </CommandPaletteProvider>
  );
});

const globalSearchCategoryToFriendly: Record<GlobalSearchCategory, string> = {
  conversations: "Conversations",
  orders: "Orders",
  returns: "Returns",
  customers: "Customers",
  pages: "Pages",
  documentation: "Help Articles",
};

const filters: CommandPaletteFilter[] = globalSearchCategory.map(
  (category): CommandPaletteFilter => ({
    id: category,
    label: globalSearchCategoryToFriendly[category],
    enabled: false,
    visible: true,
  }),
);
